import { MapProperties } from '@datum-group/datum-map/lib';
import { services } from '../../../../../API';
import { Categories } from '../../../../../API/resources/news';
import { EntityLoader } from '../../../../../store/EntityLoader';
import {
  MouseController,
  NewsCardMouseControllerLink,
} from '../../../../../store/MouseController';
import {
  INewsCategories,
  INewsItemProperties,
  INewsLayerController,
} from '../../../../../store/News/types';
import { NewsMapWidgetLayerController } from '../../../../../store/News/MapWidgetLayerController';
import { SingleWindow } from '../../../../../store/Window';

export class MapWidgetNewsStore {
  readonly layerLoader: INewsLayerController;
  readonly cardToMouseLink: NewsCardMouseControllerLink;
  readonly card: SingleWindow<INewsItemProperties>;
  readonly categoriesLoader: INewsCategories;

  constructor(mapProperties: MapProperties, mouseController: MouseController) {
    this.layerLoader = new NewsMapWidgetLayerController(
      services.newsGeoJSONLayer.get,
      mapProperties,
    );

    this.card = new SingleWindow<INewsItemProperties>();
    this.cardToMouseLink = new NewsCardMouseControllerLink(
      mouseController,
      this.card,
    );

    this.categoriesLoader = new EntityLoader<Categories[]>({
      load: services.newsCategories.get,
    });
  }
}
